import { render, staticRenderFns } from "./Business-Users.vue?vue&type=template&id=4008ef0f&scoped=true"
import script from "./Business-Users.vue?vue&type=script&lang=js"
export * from "./Business-Users.vue?vue&type=script&lang=js"
import style0 from "./Business-Users.vue?vue&type=style&index=0&id=4008ef0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4008ef0f",
  null
  
)

export default component.exports